<div *ngIf="!shelf.inactive" class="shelf col-md-12 mt-5" [ngClass]="{
    'target-mobile': isMobile, 
    'target-desktop': isDesktop
  }">
  <div class="shelf-header row mb-3 align-items-end">
    <div class="title col-md-6" *ngIf="shelf.name">
      <i *ngIf="shelf.iconClass" [ngClass]="shelf.iconClass">
        <ng-container *ngIf="shelf.iconClass.includes('material')">
          {{ shelf.iconContent }}
        </ng-container>
      </i>
      <span class="title-text">{{ shelf.name }}</span>
    </div>
    <div class="shelf-header__action col-md-6 text-right pr-4" *ngIf="shelf.type === 'VEHICLE' || shelf.type === 'FAST_QUOTE'">
      <button class="btn btn-primary btn-rounded text-white btn-show-all" (click)="seeAll()">
        Ver todos
        <i class="fa-solid fa-chevron-right show-all-arrow" aria-hidden="true"></i>
      </button>
    </div>
  </div>
  <ng-container [ngSwitch]="shelf.type">
    <div *ngSwitchCase="'BANNER'">
      <app-shelf-banner-item [shelf]="shelf"></app-shelf-banner-item>
    </div>

    <div *ngSwitchCase="'CAROUSEL'" class="carousel-container">
      <app-shelf-carousel-item [shelf]="shelf"></app-shelf-carousel-item>
    </div>

    <div *ngSwitchCase="'GRID'">
      <app-shelf-grid-item [shelf]="shelf"></app-shelf-grid-item>
    </div>

    <div *ngSwitchCase="'HTML'" [innerHTML]="safeHtmlContent"></div>

    <div *ngIf="!noResult">
      <ng-container *ngIf="!loading && shelf.type != 'OEM_DEALER'">
        <div class="shelf-mobile" *ngIf="isMobileViewport">
          <div class="shelf-track" #shelfTrack (scroll)="onTrackScroll($event)">
            <div class="track-item" app-card-vehicle-home *ngFor="let vehicle of allVehicles"
              [vehicle]="vehicle" [gridMode]="true"
              [isFastQuote]="shelf?.type == 'FAST_QUOTE'" [ownsVehicle]="false"></div>
          </div>

          <div class="track-dots" *ngIf="allVehicles.length > 1">
            <button
              type="button"
              class="dot"
              *ngFor="let slide of slideIndicators"
              [class.active]="slide === activeSlide"
              (click)="goToSlide(slide)"
              [attr.aria-label]="'Ir para o anúncio ' + (slide + 1)"
            ></button>
          </div>
        </div>

        <div class="row card-list-container" *ngIf="!isMobileViewport">
          <div class="prev-img" [ngClass]="{'final': !prevFinal}" (click)="onPrevClick()">
            <i class="fa-solid fa-chevron-circle-left"></i>
          </div>
          <div [@animate]="{
              value: '*',
              params: {
                y: '120px',
                opacity: '0',
                delay: '100ms',
                duration: '400ms'
              }
            }" class="card-list mr-3 mt-0 m-grid" app-card-vehicle-home *ngFor="let vehicle of vehicles; let i = index"
            [ngClass]="{ 'first': i == 0 }" [vehicle]="vehicle" [gridMode]="true"
            [isFastQuote]="shelf?.type == 'FAST_QUOTE'" [ownsVehicle]="false"></div>
          <div class="next-img" [ngClass]="{'final': !nextFinal}" (click)="onNextClick()">
            <i class="fa-solid fa-chevron-circle-right"></i>
          </div>
        </div>
      </ng-container>

      <div class="row" *ngIf="!loading && shelf.type == 'OEM_DEALER'">
        <app-oem-dealers-slider [isHome]="true" (clickSlider)="clickSlider($event)"></app-oem-dealers-slider>
      </div>

      <div class="row" *ngIf="loading">
        <div [@animate]="{
        value: '*',
        params: {
          y: '120px',
          opacity: '0',
          delay: '100ms',
          duration: '400ms'
        }
      }" class="card-list mr-3 mt-0 m-grid" app-card-vehicle-loader *ngFor="let card of cardsQuantity; let i = index"
          [ngClass]="{ 'first': i == 0 }"></div>
      </div>
    </div>

  </ng-container>
</div>